import { safeReturnTo } from '../Delivery/Registries/returnTo';
const enc = encodeURIComponent;
function basePath(ref) {
    const id = enc(ref.id);
    switch(ref.kind){
        case 'CONTACT':
            return `/registries/contacts/${id}`;
        case 'COMPANY':
            return `/registries/companies/${id}`;
        case 'GOVERNMENT_ORG':
            return `/registries/gov-orgs/${id}`;
        case 'VEHICLE':
            return `/registries/vehicles/${id}`;
        case 'LCAT_ANCHOR':
            return `/registries/labor-categories/${id}`;
        case 'LCAT_ENTRY':
            return `/registries/labor-categories/entries/${id}`;
        case 'PURSUIT':
            return `/capture/${id}`;
        case 'PROGRAM':
            return `/delivery/programs/${id}`;
        case 'PROPOSAL':
            return `/proposal/${id}/v2`;
        case 'RFI_RESPONSE':
            return `/rfi-response/${id}`;
        case 'REGISTRY_CONTRACT':
            // Contracts have no full page; the inline record on the Contracts tab.
            return `/registries?tab=contracts&record=${id}`;
        case 'PRICING_SHEET':
            // id = the pricing-sheet change set id.
            return `/registries/pricing-sheets/${id}`;
        case 'LANDSCAPE':
            return `/landscapes/${id}`;
        case 'ARTIFACT':
            // The Library page opens a record from ?record= (same link the app search builds).
            return `/library?record=${id}`;
        default:
            return null;
    }
}
/**
 * The one href builder for registry references (REG-08). Registry kinds go to
 * their full record pages; the rest go to the page that already owns them.
 * `origin` (path + search of the linking page) becomes `returnTo` only when the
 * Registries validator accepts it. Returns null for an empty or unknown kind,
 * or an EXTERNAL ref without a URL, so callers render plain text instead.
 */ export function registryHref(ref, origin) {
    if (!ref.kind) return null;
    if (ref.kind === 'EXTERNAL') return ref.externalUrl ? ref.externalUrl : null;
    if (!ref.id) return null;
    const base = basePath(ref);
    if (!base) return null;
    const returnTo = origin ? safeReturnTo(origin) : null;
    if (!returnTo) return base;
    const joiner = base.includes('?') ? '&' : '?';
    return `${base}${joiner}returnTo=${enc(returnTo)}`;
}
